import { get } from '@core/api/baseApi';

export const getReportsCreatedByUser = async (studyInstanceUid: string,): Promise<string[]> => {
  return await get(`/studies/${studyInstanceUid}/reports/user`);
};
